import { Range } from '@attain-apps/range'

import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Metrics',
      type: 'report-card',
      content: {
        '[]': [
          {
            '{}': {
              name: 'Total',
              values: {
                '[]': [
                  {
                    '{}': {
                      name: 'TDC',
                      value: {
                        '{}': {
                          aside: 'goal of 290M',
                          quality: {
                            if: [
                              [
                                {
                                  '>=': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'glExpenses',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'tdcAmount',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    290000000,
                                  ],
                                },
                                'good',
                              ],
                              'bad',
                            ],
                          },
                          tooltip:
                            'Total Direct Cost - All direct expenses charged to a research project.',
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'glExpenses',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'tdcAmount',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                scalar: 0.000001,
                                suffix: 'M',
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'MTDC',
                      value: {
                        '{}': {
                          aside: 'goal of 210M',
                          quality: {
                            if: [
                              [
                                {
                                  '>=': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'glExpenses',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'mtdcAmount',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    210000000,
                                  ],
                                },
                                'good',
                              ],
                              'bad',
                            ],
                          },
                          tooltip:
                            'Modified Total Direct Cost - TDC excluding equipment, capital costs, patient care, tuition, and large subawards.',
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'glExpenses',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'mtdcAmount',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                scalar: 0.000001,
                                suffix: 'M',
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'MTDC Average',
                      value: {
                        '{}': {
                          aside: 'goal of 210M',
                          quality: {
                            if: [
                              [
                                {
                                  '>=': [
                                    {
                                      '/': [
                                        {
                                          '+': {
                                            '@': 'glExpensesInMtdcInLastThreeYears',
                                          },
                                        },
                                        3,
                                      ],
                                    },
                                    210000000,
                                  ],
                                },
                                'good',
                              ],
                              'bad',
                            ],
                          },
                          tooltip: 'MTDC Average',
                          emphasis: {
                            'fmt.num': [
                              {
                                '/': [
                                  {
                                    '+': {
                                      '@': 'glExpensesInMtdcInLastThreeYears',
                                    },
                                  },
                                  3,
                                ],
                              },
                              {
                                scalar: 0.000001,
                                suffix: 'M',
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'IDC-R',
                      value: {
                        '{}': {
                          aside: 'goal of 150M',
                          quality: {
                            if: [
                              [
                                {
                                  '>=': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'glExpenses',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'idcrAmount',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    150000000,
                                  ],
                                },
                                'good',
                              ],
                              'bad',
                            ],
                          },
                          tooltip:
                            'Indirect Cost Recovery - Indirect costs recovered from sponsors based on negotiated rates.',
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'glExpenses',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'idcrAmount',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                scalar: 0.000001,
                                suffix: 'M',
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Award Funding',
                      value: {
                        '{}': {
                          aside: 'goal of 150M',
                          quality: {
                            if: [
                              [
                                {
                                  '>=': [
                                    {
                                      '+': {
                                        '@': 'awardFundings',
                                      },
                                    },
                                    150000000,
                                  ],
                                },
                                'good',
                              ],
                              'bad',
                            ],
                          },
                          tooltip:
                            'Total funding obligated by a sponsor for a specific award.',
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '@': 'awardFundings',
                                },
                              },
                              {
                                scalar: 0.000001,
                                suffix: 'M',
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'ASF',
                      value: {
                        '{}': {
                          aside: 'Sq. Ft.',
                          quality: 'good',
                          tooltip: 'Total Assignable Square Footage',
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'rooms',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                ],
              },
            },
          },
          {
            '{}': {
              name: 'Density',
              values: {
                '[]': [
                  {
                    '{}': {
                      name: 'TDC Density',
                      value: {
                        '{}': {
                          aside: 'goal of 500 / ASF',
                          quality: {
                            if: [
                              [
                                {
                                  '>=': [
                                    {
                                      '/': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'glExpenses',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'tdcAmount',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'rooms',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'asf',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    500,
                                  ],
                                },
                                'good',
                              ],
                              'bad',
                            ],
                          },
                          tooltip: 'Total TDC / Total ASF',
                          emphasis: {
                            'fmt.num': [
                              {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'glExpenses',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'tdcAmount',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'MTDC Density',
                      value: {
                        '{}': {
                          aside: 'goal of 200 / ASF',
                          quality: {
                            if: [
                              [
                                {
                                  '>=': [
                                    {
                                      '/': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'glExpenses',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'mtdcAmount',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'rooms',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'asf',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    200,
                                  ],
                                },
                                'good',
                              ],
                              'bad',
                            ],
                          },
                          tooltip: 'Total MTDC / Total ASF',
                          emphasis: {
                            'fmt.num': [
                              {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'glExpenses',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'mtdcAmount',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'MTDC Avg Density',
                      value: {
                        '{}': {
                          aside: 'goal of 200 / ASF',
                          quality: {
                            if: [
                              [
                                {
                                  '>=': [
                                    {
                                      '/': [
                                        {
                                          '/': [
                                            {
                                              '+': {
                                                '@': 'glExpensesInMtdcInLastThreeYears',
                                              },
                                            },
                                            3,
                                          ],
                                        },
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'rooms',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'asf',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    200,
                                  ],
                                },
                                'good',
                              ],
                              'bad',
                            ],
                          },
                          tooltip: '3-Year MTDC Average / Total ASF',
                          emphasis: {
                            'fmt.num': [
                              {
                                '/': [
                                  {
                                    '/': [
                                      {
                                        '+': {
                                          '@': 'glExpensesInMtdcInLastThreeYears',
                                        },
                                      },
                                      3,
                                    ],
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'IDC-R Density',
                      value: {
                        '{}': {
                          aside: 'goal of 100 / ASF',
                          quality: {
                            if: [
                              [
                                {
                                  '>=': [
                                    {
                                      '/': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'glExpenses',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'idcrAmount',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'rooms',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'asf',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    100,
                                  ],
                                },
                                'good',
                              ],
                              'bad',
                            ],
                          },
                          tooltip: 'Total IDC-R / Total ASF',
                          emphasis: {
                            'fmt.num': [
                              {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'glExpenses',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'idcrAmount',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                ],
              },
            },
          },
          {
            '{}': {
              name: 'Other',
              values: {
                '[]': [
                  {
                    '{}': {
                      name: 'Effective Recovery',
                      value: {
                        '{}': {
                          aside: 'goal of 39%',
                          quality: {
                            if: [
                              [
                                {
                                  '>=': [
                                    {
                                      '/': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'glExpenses',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'idcrAmount',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'glExpenses',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'mtdcAmount',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    0.39,
                                  ],
                                },
                                'good',
                              ],
                              'bad',
                            ],
                          },
                          tooltip:
                            'Actual indirect costs recovered after waivers and cost-sharing adjustments',
                          emphasis: {
                            'fmt.num': [
                              {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'glExpenses',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'idcrAmount',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'glExpenses',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'mtdcAmount',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                              {
                                ',': true,
                                '.': {
                                  max: 2,
                                  min: 2,
                                },
                                scalar: 100,
                                suffix: '%',
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Utilization',
                      value: {
                        '{}': {
                          aside: 'goal of 80%',
                          quality: {
                            if: [
                              [
                                {
                                  '>=': [
                                    {
                                      '/': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'rooms',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'asf',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'rooms',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'sqft',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    0.8,
                                  ],
                                },
                                'good',
                              ],
                              'bad',
                            ],
                          },
                          tooltip:
                            'Percentage of ASF actively used for research.',
                          emphasis: {
                            'fmt.num': [
                              {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'sqft',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                              {
                                ',': true,
                                '.': {
                                  max: 2,
                                  min: 2,
                                },
                                scalar: 100,
                                suffix: '%',
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Collaboration Percentage',
                      value: {
                        '{}': {
                          aside: 'goal of 80%',
                          quality: {
                            if: [
                              [
                                {
                                  '>=': [
                                    {
                                      '/': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'projects',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'collaboration',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          '#': {
                                            '@': 'projects',
                                          },
                                        },
                                      ],
                                    },
                                    0.8,
                                  ],
                                },
                                'good',
                              ],
                              'bad',
                            ],
                          },
                          tooltip:
                            'Percentage of all projects that are classified as collaborative.',
                          emphasis: {
                            'fmt.num': [
                              {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'projects',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'collaboration',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '#': {
                                      '@': 'projects',
                                    },
                                  },
                                ],
                              },
                              {
                                ',': true,
                                '.': {
                                  max: 2,
                                  min: 2,
                                },
                                scalar: 100,
                                suffix: '%',
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                ],
              },
            },
          },
        ],
      },
    },
  },
  variables: {
    focusedRange: {
      $range: {
        end: {
          $date: '12/31/2024',
        },
        start: {
          $date: '1/1/2024',
        },
      },
    },
    researchType: ['BASIC RESEARCH'],
  },
  subqueries: {
    rooms: {
      filter: {
        or: [
          {
            '=': [
              {
                '@$': 'spaceType',
              },
              null,
            ],
          },
          {
            in: [
              {
                '@.': [
                  '!space_use',
                  {
                    ref: {
                      entity: '!group',
                    },
                  },
                ],
              },
              {
                '@>': [
                  {
                    '@$': 'spaceType',
                  },
                  'ent:!space_use:!group',
                ],
              },
            ],
          },
        ],
      },
      target: 'ent:!space:!room',
      selection: {
        '{}': {
          asf: {
            '*': [
              {
                '@.': '!sqft',
              },
              {
                '/': [
                  {
                    '+': {
                      '->': [
                        {
                          '@': 'weights',
                        },
                        {
                          '*': [
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'value',
                              ],
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'allowable',
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  },
                  {
                    '+': {
                      '->': [
                        {
                          '@': 'weights',
                        },
                        {
                          '@>': [
                            {
                              '@$': '$value',
                            },
                            'value',
                          ],
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
          sqft: {
            '@.': '!sqft',
          },
        },
      },
      subqueries: {
        weights: {
          ref: {
            attr: 'attr:ent#!space_funcl#!entry:!space',
            inherit: '-',
          },
          filter: {
            '!=': [
              {
                '@.': '!weight',
              },
              0,
            ],
          },
          target: 'ent:!space_funcl:!entry',
          selection: {
            '{}': {
              value: {
                '@.': '!weight',
              },
              allowable: {
                if: [
                  [
                    {
                      '!=': [
                        {
                          '@': 'funcIdCat',
                        },
                        null,
                      ],
                    },
                    1,
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            funcIdCat: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!func_space',
              },
              target: 'ent:!func_space:!func',
              selection: {
                '@.': [
                  '!func_idc',
                  {
                    ref: {
                      entity: '!cat',
                    },
                  },
                ],
              },
            },
          },
        },
      },
    },
    projects: {
      target: 'ent:!projects:!proj',
      selection: {
        '{}': {
          collaboration: {
            if: [
              [
                {
                  '>': [
                    {
                      '#': {
                        uniq: {
                          '@': 'piDepartments',
                        },
                      },
                    },
                    1,
                  ],
                },
                1,
              ],
              0,
            ],
          },
        },
      },
      subqueries: {
        piDepartments: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!proj',
          },
          target: 'ent:!proj_pis:!entry',
          selection: {
            '@': 'piDept',
          },
          subqueries: {
            piDept: {
              ref: {
                attr: 'attr:ent#!proj_pis#!entry:!pi',
              },
              target: 'ent:!personnel:!employee',
              selection: {
                '@.': [
                  '!org',
                  {
                    ref: {
                      entity: '!dept',
                    },
                  },
                ],
              },
            },
          },
        },
      },
    },
    glExpenses: {
      filter: {
        and: [
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'researchType',
                  },
                  null,
                ],
              },
              {
                in: [
                  {
                    '@': 'researchType',
                  },
                  {
                    '@$': 'researchType',
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!proj',
              },
              null,
            ],
          },
        ],
      },
      period: {
        '@$': 'focusedRange',
      },
      target: 'ent:!gl_exp:!entry',
      selection: {
        '{}': {
          tdcAmount: {
            if: [
              [
                {
                  '!=': [
                    {
                      '@.': [
                        '!acct',
                        {
                          ref: {
                            entity: '!acct',
                          },
                        },
                      ],
                    },
                    '?7631013',
                  ],
                },
                {
                  '@.': '!amount',
                },
              ],
              0,
            ],
          },
          idcrAmount: {
            if: [
              [
                {
                  '=': [
                    {
                      '@.': [
                        '!acct',
                        {
                          ref: {
                            entity: '!acct',
                          },
                        },
                      ],
                    },
                    '?7631013',
                  ],
                },
                {
                  '@.': '!amount',
                },
              ],
              0,
            ],
          },
          mtdcAmount: {
            if: [
              [
                {
                  '@': 'isInMtdc',
                },
                {
                  '@.': '!amount',
                },
              ],
              0,
            ],
          },
        },
      },
      subqueries: {
        isInMtdc: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!acct',
          },
          target: 'ent:!gl_accts:!acct',
          selection: {
            '@.': '!is_in_mtdc',
          },
        },
        researchType: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          target: 'ent:!projects:!proj',
          selection: {
            '@.': '!research_type_wfuhs',
          },
        },
      },
    },
    awardFundings: {
      filter: {
        or: [
          {
            '=': [
              {
                '@$': 'researchType',
              },
              null,
            ],
          },
          {
            in: [
              {
                '@.': '!research_type_wfuhs',
              },
              {
                '@$': 'researchType',
              },
            ],
          },
        ],
      },
      target: 'ent:!awards:!award',
      selection: {
        '@.': '!budget',
      },
    },
    glExpensesInMtdcInLastThreeYears: {
      filter: {
        and: [
          {
            '!=': [
              {
                '@.': '!proj',
              },
              null,
            ],
          },
          {
            '@': 'isInMtdc',
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'researchType',
                  },
                  null,
                ],
              },
              {
                in: [
                  {
                    '@': 'researchType',
                  },
                  {
                    '@$': 'researchType',
                  },
                ],
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2024',
          },
          start: {
            $date: '1/1/2022',
          },
        },
      },
      target: 'ent:!gl_exp:!entry',
      selection: {
        '@.': '!amount',
      },
      subqueries: {
        isInMtdc: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!acct',
          },
          target: 'ent:!gl_accts:!acct',
          selection: {
            '@.': '!is_in_mtdc',
          },
        },
        researchType: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          target: 'ent:!projects:!proj',
          selection: {
            '@.': '!research_type_wfuhs',
          },
        },
      },
    },
  },
}
